import React from 'react';
import ReactApexCharts from 'react-apexcharts';
import PropTypes from 'prop-types';

function LineChartSeries({ labels, series, colors, isLoading }) {
  const options = {
    stroke: {
      curve: 'smooth',
    },
    xaxis: {
      categories: labels,
    },
    tooltip: {
      x: {
        format: 'dd/MM/yy HH:mm',
      },
    },
    chart: {
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    colors,
  };

  if (isLoading) {
    return (
      <div className="h-full w-full pl-10 py-8 pr-6">
        <div
          className="animate-pulse bg-neutral-100 h-full w-full rounded"
          style={{
            clipPath:
              'polygon(0 80%, 13% 71%, 25% 55%, 39% 44%, 54% 51%, 66% 46%, 78% 34%, 90% 22%, 100% 33%, 100% 43%, 100% 100%, 0% 100%)',
          }}
        />
      </div>
    );
  }

  return (
    <ReactApexCharts
      height="100%"
      options={options}
      series={series}
      type="area"
    />
  );
}
LineChartSeries.defaultProps = {
  labels: [],
  series: [],
  colors: [],
  isLoading: false,
};

LineChartSeries.propTypes = {
  labels: PropTypes.instanceOf(Array),
  series: PropTypes.instanceOf(Array),
  colors: PropTypes.instanceOf(Array),
  isLoading: PropTypes.bool,
};

export default LineChartSeries;
